module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "fm1"
    }
  }, [_c('p', {
    staticClass: "heading"
  }, [_c('span', [_vm._v("ACCLAIM FOR")])]), _vm._v(" "), _c('p', {
    staticClass: "heading1"
  }, [_c('span', [_vm._v("UP THROUGH THE WATER:")])]), _vm._v(" "), _c('p', [_vm._v("“With "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Up Through the Water")]), _vm._v(" Darcey Steinke announces herself as a fine fiction writer who also has a poet's touch; this novel is remarkable for a number of things, but perhaps most of all for the originality and delicacy of its imagery, and for the intensity of its frequent lyrical moments. There's a strong and interesting story here, but the language that carries the reader is stronger still.”")]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_vm._v("—Madison Smartt Bell")]), _vm._v(" "), _c('p', {
    staticClass: "marg"
  }, [_vm._v("“"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Up Through the Water")]), _vm._v(" by Darcey Steinke details one sensuous, beachy summer. . . . Like summer-island life itself, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Up Through the Water")]), _vm._v(" has a meandering, languid pace. One reads this book sentence by sentence marveling at Steinke's imagistic competence . . . she has sought to portray characters looking up, out, beyond the confines of self and circumstance.”")]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_vm._v("—Marianne Gingher, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Washington Post Book World")])]), _vm._v(" "), _c('p', {
    staticClass: "marg"
  }, [_vm._v("“The familiar materials of the novel are as fresh as a breeze off the ocean in Darcey Steinke's treatment. The book can be read in a couple of hours, but it lingers like memories.”")]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_vm._v("—William L. Tazewell, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Virginian-Pilot and Ledger-Star")])]), _vm._v(" "), _c('p', {
    staticClass: "marg"
  }, [_vm._v("“So apt that you feel the sand in your shorts by page 162 . . . filled with significant little whispers that echo as if from a shell . . . [Emily's] nature unrolls as slowly as a breeze might sway bindweed, and develops as quietly and surely as that of Raskolnikov in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Crime and Punishment")]), _vm._v(" or of the antagonist of Hawthorne's "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Scarlet Letter.")]), _vm._v(" . . . Wise swimmers will dive in here.”")]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_vm._v("—George Myers, Jr., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Columbus Dispatch")])]), _vm._v(" "), _c('p', {
    staticClass: "marg"
  }, [_vm._v("“A precise evocation of place . . . a gifted stylist . . . Ocracoke Island springs into sharp focus. The reader smells the sea, feels the grit of sand, almost squints against the glint of sun on water. . . . Vigorous characters that we cannot help but care about, doing interesting things in a place that is vivid and distinctive.”")]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_vm._v("—Chauncey Mabe, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Fort Lauderdale")]), _vm._v(" Sun-Sentinel")]), _vm._v(" "), _c('p', {
    staticClass: "marg"
  }, [_vm._v("“[A] poetic first novel . . . Steinke's imagery is at once vivid and delicate. . . . An intriguing debut that hints at promising work to come.”")]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("—Publishers Weekly")])]), _vm._v(" "), _c('p', {
    staticClass: "marg"
  }, [_vm._v("“This debut novel . . . captures all the intensity of islands in summer-time. . . . Steinke writes with wonderful clarity.”")]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("—Kirkus Reviews")])]), _vm._v(" "), _c('p', {
    staticClass: "marg"
  }, [_vm._v("“"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Up Through the Water")]), _vm._v(" is beautifully done, a startlingly good debut.”")]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("—The Washingtonian")])]), _vm._v(" "), _c('p', {
    staticClass: "marg"
  }, [_vm._v("“"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Up Through the Water")]), _vm._v(" is a wonderful book—fresh, vital, filled with characters whom you want to remember. The writing is poetic, the images new and invigorating.”")]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_vm._v("—Ben Greer")]), _vm._v(" "), _c('p', {
    staticClass: "marg"
  }, [_vm._v("“A novelist with a poet's eye.”")]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_vm._v("—Lex Alexander, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Greensboro News & Record")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-238ffa7b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/acclaim_for_up_through_the_water.vue
// module id = 63
// module chunks = 0